module.exports = __webpack_public_path__ + "static/media/speedometer.cda18fb9.svg";